<!-- Administrative Remarks Bottom Sheet Design -->
<div class="admin-remarks-container" *ngIf="isApproved()">
	<!-- Minimal Top Header Bar -->
	<div class="minimal-remarks-bar" (click)="toggleBottomSheet()">
		<div class="remarks-left">
			<!-- Status Icon Only -->
			<!-- <div class="compact-remarks-status">
				<div class="status-icon-wrapper" [class]="getStatusColor()">
					<i [class]="getStatusIcon()"></i>
				</div>
			</div> -->
		</div>

		<div class="remarks-center">
			<!-- Administrative Remarks Title -->
			<div class="remarks-summary">
				<div class="remarks-icon">
					<i class="fas fa-clipboard-list"></i>
				</div>
				<span class="remarks-title">Administrative Remarks</span>
			</div>
		</div>

		<div class="remarks-right">
			<!-- Info Indicator -->
			<div class="info-indicator">
				<i class="fas fa-chevron-up" [class.rotated]="!isBottomSheetOpen"></i>
				<div class="notification-badges">
					<!-- Alert notification badge -->
					<div class="notification-dot alert-dot" *ngIf="remarkPresent && !remarkResolved"></div>
				</div>
			</div>
		</div>
	</div>

	<!-- Bottom Sheet Overlay -->
	<div class="bottom-sheet-overlay" [class.active]="isBottomSheetOpen" (click)="closeBottomSheet()"> </div>

	<!-- Bottom Sheet Content -->
	<div class="admin-remarks-bottom-sheet" [class.open]="isBottomSheetOpen">
		<!-- Bottom Sheet Handle -->
		<div class="bottom-sheet-handle">
			<div class="handle-bar"></div>
		</div>

		<!-- Bottom Sheet Header -->
		<div class="bottom-sheet-header">
			<h6 class="sheet-title">Administrative Remarks</h6>
			<button type="button" class="close-btn" (click)="closeBottomSheet()" aria-label="Close">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<!-- Bottom Sheet Body -->
		<div class="bottom-sheet-body">
			<!-- Remarks Status Section -->
			<div class="sheet-section status-section">
				<div class="section-header">
					<i class="fas fa-info-circle"></i>
					<span>Status & Information</span>
				</div>

				<div class="section-content">
					<!-- Full Status Badge -->
					<div class="full-status-badge">
						<ion-badge [color]="getStatusColor()" class="status-badge">
							<i [class]="getStatusIcon()" class="me-1"></i>
							{{ getStatusLabel() }}
						</ion-badge>
					</div>

					<!-- Admin Info (if present) -->
					<div class="admin-info" *ngIf="remarkPresent">
						<div class="info-card">
							<div class="info-icon">
								<i class="fas fa-user-shield"></i>
							</div>
							<div class="info-content">
								<div class="info-title">Administrative Review</div>
								<div class="info-subtitle">Form reviewed and remarks provided</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Remarks Content Section -->
			<div class="sheet-section remarks-section">
				<div class="section-header">
					<i class="fas fa-comment-alt"></i>
					<span>Remarks Content</span>
				</div>

				<div class="section-content">
					<!-- Remarks Display for Non-Admins or Read-Only -->
					<div class="remarks-display" *ngIf="!canUpdate() && remarkPresent">
						<div class="display-card">
							<div class="display-header">
								<i class="fas fa-quote-left"></i>
								<span>Administrative Remarks</span>
							</div>
							<div class="display-content">
								<p>{{ adminRemark }}</p>
							</div>
						</div>
					</div>

					<!-- Remarks Editor for Admins -->
					<div class="remarks-editor" *ngIf="canUpdate()">
						<div class="form-group">
							<label class="form-label" for="adminRemarksTextarea">
								Administrative Remarks
								<i class="fas fa-question-circle ms-1" title="Enter administrative remarks for this form"></i>
							</label>
							<textarea
								id="adminRemarksTextarea"
								class="form-control"
								rows="4"
								[(ngModel)]="adminRemark"
								placeholder="Enter your administrative remarks here..."
								[disabled]="!canUpdate()"
							></textarea>
							<div class="character-count" *ngIf="adminRemark"> {{ adminRemark.length }} characters </div>
						</div>
					</div>

					<!-- No Remarks Message -->
					<div class="no-remarks-message" *ngIf="!remarkPresent && !canUpdate()">
						<div class="empty-state">
							<i class="fas fa-clipboard-check"></i>
							<h6>No Administrative Remarks</h6>
							<p>No administrative remarks have been provided for this form.</p>
						</div>
					</div>
				</div>
			</div>

			<!-- Actions Section (Admin Only) -->
			<div class="sheet-section actions-section" *ngIf="canUpdate()">
				<div class="section-header">
					<i class="fas fa-cogs"></i>
					<span>Administrative Actions</span>
				</div>

				<div class="section-content">
					<div class="action-buttons">
						<!-- Save Button -->
						<button
							type="button"
							class="action-btn save-btn"
							*ngIf="adminRemark?.trim()?.length > 0"
							(click)="saveRemark()"
						>
							<i class="fas fa-save"></i>
							<span>Save Remarks</span>
						</button>

						<!-- Resolve/Open Button -->
						<button
							type="button"
							class="action-btn resolve-btn"
							*ngIf="remarkPresent && !remarkResolved"
							(click)="markResolved()"
						>
							<i class="fas fa-check-circle"></i>
							<span>Mark as Resolved</span>
						</button>

						<button
							type="button"
							class="action-btn open-btn"
							*ngIf="remarkPresent && remarkResolved"
							(click)="markOpen()"
						>
							<i class="fas fa-redo-alt"></i>
							<span>Reopen Remarks</span>
						</button>

						<!-- Delete Button -->
						<button
							type="button"
							class="action-btn delete-btn"
							*ngIf="adminRemark?.trim()?.length > 0"
							(click)="deleteRemark()"
						>
							<i class="fas fa-trash-alt"></i>
							<span>Delete Remarks</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
